module.exports = __webpack_public_path__ + "img/puroak.icon.leaf.asset.0ba66b02.svg";